import { DatasetEntry } from '@hooks/useCatalog'
import type { TreeNode } from 'src/types/global'

export function findPathToNode(
  nodes: TreeNode[],
  targetId: string
): string[] | null {
  for (const node of nodes) {
    if (node.id === targetId) {
      return [node.id]
    }
    if (node.children) {
      const childPath = findPathToNode(node.children, targetId)
      if (childPath) {
        return [node.id, ...childPath]
      }
    }
  }
  return null
}

export function catalog2tree(catalog: DatasetEntry[]): TreeNode[] {
  const root: TreeNode = { id: '', name: '', children: [], type: 'collection' }

  for (const x of catalog) {
    const el = { ...x }
    let parent = root
    const tx = [...(el.taxonomy || [])]

    if (el.connectorId) {
      // TODO: this pseudo-taxonomy creation could be improved
      tx.push(el.title)
      el.title = `${el.connector}:${el.connectorId}`
    }

    for (const bit of tx) {
      const existing = parent.children?.find((c) => c.id === bit)
      if (existing) {
        parent = existing
      } else {
        const newBranch: TreeNode = {
          id: bit,
          name: bit,
          children: [],
          type: 'collection'
        }
        parent.children!.push(newBranch)
        parent = newBranch
      }
    }

    parent.children!.push({
      id: el.id,
      name: el.title,
      type: 'dataset',
      source: el.schema === 'keyed' ? 'mydata' : 'catalog'
    })
  }

  return root.children || []
}
